/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { SubPage, Copy, BodyCopy, CTAs, Button, displayModal, displayErrorMessage } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './approvemodal_styles';

/* ========== ~~~~~~~~~~ CANCEL IMPORT POPUP~~~~~~~~~~ ========== */
const ApproveModal = props => {
    const { handleApprove, handleCancel} = props
    const [isProcessing, setIsProcessing ] = useState(false)

    return (
        <SubPage name={`approvepopup`}  klass={props.classes.approvepopup} >
            <Copy name={`approvepopup`}>
                <BodyCopy>
                    <p>Are you sure you want to delete</p>
                    <p>this report?</p>
                </BodyCopy>

            </Copy>
            <Copy name={`approvePopupContent`}>
                <BodyCopy name={`content`}>Once you delete it, you will not be able to recover it again.</BodyCopy>
            </Copy>
            <CTAs name={`ctas`} >
                <Button type={`action`} handleClick={handleCancel} variant={`normal`} name={`cancel`} text={`Cancel`} />
                <Button type={'action'} handleClick={() => { handleApprove() }} variant={`action`} name={`approve`} text={`Delete Report`} processingText={'Deleting Report...'} />
            </CTAs>
        </SubPage>
    );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ApproveModal);